import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {  Mail, Github, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="py-12 bg-black/95 backdrop-blur-md border-t border-white/10">
            <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-4 gap-8">
                    <div>
                        <h3 className="text-xl font-bold text-white mb-4">
                            HYPER COGNITIVE
                        </h3>
                        <p className="text-gray-400">
                            Transforming ideas into digital reality since 2024.
                        </p>
                    </div>
                    
                    <div>
                        <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col gap-4">
                                <a href="/" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    Home
                                </a>
                                <a href="/aiDAPTIV+" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    aiDAPTIV+
                                </a>
                                <a href="/solutions" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    Solutions
                                </a>
                                <a href="/appliances" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    Hardware
                                </a>
                            </div>
                            <div className="flex flex-col gap-4">
                                <a href="/about" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    About
                                </a>
                                <a href="/contact" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    Contact
                                </a>
                                {/* <a href="/careers" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    Careers
                                </a> */}
                                <a href="/faqs" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300">
                                    FAQs
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <h4 className="text-lg font-semibold text-white mb-4">Contact Info</h4>
                        <div className="flex flex-col gap-4">
                            <div className="flex items-center gap-2 text-gray-400">
                                <Mail className="h-4 w-4" />
                                <a href="mailto:ambat@hyco.ai" className="hover:text-emerald-400 transition-colors duration-300">
                                    support@hyco.ai
                                </a>
                            </div>
                            <div className="text-gray-400">HYPER COGNITIVE TECHNOLOGIES PVT LTD, #238/2 ,6th Cross, Near BWSSB Water Tank, OMBR Layout, Banaswadi, Kalyananagar Bangalore - 560043</div>
                        </div>
                    </div>
                    
                    
                </div>
                
                <div className="mt-12 pt-8 border-t border-white/10">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400 text-sm">
                            © {new Date().getFullYear()} HYPER COGNITIVE. All rights reserved.
                        </p>
                        <div className="flex space-x-6 mt-4 md:mt-0">
                            <a href="/privacyandpolicy" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 text-sm">
                                Privacy Policy
                            </a>
                            <a href="/termsandconditions" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 text-sm">
                                Terms of Service
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
